// index.js  – with CRT pre-loader overlay
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import LoaderOverlay from './LoaderOverlay';   // ← добавили

const container = document.getElementById('root');
const root = createRoot(container);

function RootWithLoader() {
  const initialReady = React.useMemo(() => {
    if (typeof window === 'undefined') return false;
    if (window.__appBootstrapped) return true;
    try {
      return sessionStorage.getItem('appBootstrapped') === '1';
    } catch {
      return false;
    }
  }, []);

  const [ready, setReady] = React.useState(initialReady);

  const handleDone = React.useCallback(() => {
    if (typeof window !== 'undefined') {
      window.__appBootstrapped = true;
      try { sessionStorage.setItem('appBootstrapped', '1'); } catch {}
    }
    setReady(true);
  }, []);

  return ready ? <App /> : <LoaderOverlay onDone={handleDone} />;
}

root.render(
  <React.StrictMode>
    <RootWithLoader />
  </React.StrictMode>
);
